import { useClinicContext } from "src/contexts/clinic/ClinicProvider";
import { useLatestEmrHubVersion } from "src/services/emrHubInstaller/hooks/useLatestEmrHubVersion";
import { isOlderHubVersion } from "src/utils/emr/hubVersionHelper";

import { EMRHubType } from "src/services/emr/types";

export type HubUpdateTarget = Pick<
  EMRHubType,
  "appVersion" | "status" | "homeClinicId"
>;

export const useHubUpdate = (emrHub: HubUpdateTarget | undefined) => {
  const { allClinicInfo } = useClinicContext();
  const { data: latest } = useLatestEmrHubVersion();

  const canDownload = Boolean(
    emrHub?.homeClinicId &&
      allClinicInfo?.some((clinic) => clinic.id === emrHub.homeClinicId)
  );

  const isOutdated =
    emrHub?.status !== "Revoked" &&
    isOlderHubVersion(emrHub?.appVersion, latest?.version);

  return {
    canDownload,
    isOutdated,
    latestVersion: latest?.version,
  };
};
